module.exports = __webpack_public_path__ + "media/images/visa-24a3510df29d7493ba7db57e44d1fc3c.svg";